import type { ProductPlan } from '@/features/products/types';

export function savingsPercent(price: number, previousPrice?: number, fallback?: number): number | null {
  if (typeof fallback === 'number' && fallback > 0) return Math.round(fallback);
  if (previousPrice && previousPrice > price) {
    return Math.round((1 - price / previousPrice) * 100);
  }
  return null;
}

export function planSavingsPercent(plan: ProductPlan): number | null {
  return savingsPercent(plan.price, plan.previousPrice, plan.discountPercent);
}
